// this is an autogenerated file from App/Account/Chairs/Content/Appointments/Content/Appointment/Actions/ChangeChair/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Chairs_Content_Appointments_Content_Appointment_Actions_ChangeChair_Content(
  $id: uuid!
  $provider_id: numeric!
  $assistant_id: numeric!
  $chair_id: numeric!
) {
  vaxiom_appointment_booking_update(
    id: $id
    provider_id: $provider_id
    assistant_id: $assistant_id
    chair_id: $chair_id
  ) {
    id
    appointment_booking {
      id
      _id
      state
      start_time
      end_time
      local_start_date
      local_start_time
      provider_id
      assistant_id
      chair_id
    }
  }
}

`